var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientLargerCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 295,
    viewBox: "0 0 704 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654 1.25H0.25V294.75H654C681.476 294.75 703.75 272.476 703.75 245V51C703.75 23.5238 681.476 1.25 654 1.25Z",
    fill: "black",
    stroke: "url(#paint0_linear_311_1288)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 117.928C8 116.824 8.89543 115.928 10 115.928H88V187.928H8V117.928Z",
    fill: "#F68500",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M667 13.4283L453 0.822956C411.923 -0.0781936 413.133 18.7937 416.255 30.8289C420.841 42.2355 445.475 67.6785 507.317 78.1974C569.16 88.7164 613.806 128.841 628.399 147.588C640.16 161.208 664.984 187.929 681 187.928C697.017 187.927 682.472 172.082 683.702 165.428L701.088 38.7995C699.607 22.7331 673.906 13.7267 667 13.4283Z",
    fill: "url(#paint1_linear_311_1288)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_1288",
    x1: 704,
    y1: 148,
    x2: 0,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_311_1288",
    x1: 548.774,
    y1: 10.1698,
    x2: 694.661,
    y2: 159.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A00CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientLargerCard);
export default __webpack_public_path__ + "static/media/gradient-larger-card.c09a4964906ae55d1787caf807996f8d.svg";
export { ForwardRef as ReactComponent };